export default function (app) {
	app.config( [
		'$compileProvider',
		function( $compileProvider )
		{
			$compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|blob):/);
			// Angular before v1.2 uses $compileProvider.urlSanitizationWhitelist(...)
		}
	]);
};
